export const SAKTI_API_CONFIG = {
  LIVE_DASHBOARD_PATH: '/api/report/dashboard/live',
  OPTIONS_PATH: '/inspeksi/options',
  ESTATES_DB_PATH: '/inspeksi/web/estate-db',
  RKH_KPI_PATH: '/api/report/pijar/rkh/dashboard/kpi',
  RKH_LIST_PATH: '/api/report/pijar/rkh/dashboard/list',
  RKH_HARVESTERS_PATH: '/api/report/pijar/rkh/dashboard/harvesters',
  RKH_DETAIL_PATH: (rkhId: string) => `/api/report/pijar/rkh/dashboard/${rkhId}`,
  ACCESS_CODE_REQUESTS_PATH: '/api/v1/admin/access-code/requests',
  ACCESS_CODE_DETAIL_PATH: (id: string) => `/api/v1/admin/access-code/requests/${id}/code`,
  ACCESS_CODE_CANCEL_PATH: (id: string) => `/api/v1/admin/access-code/requests/${id}/cancel`,

  // BCC (Harvest)
  BCC_KPI_PATH: '/api/report/pijar/bcc/dashboard/kpi',
  BCC_LIST_PATH: '/api/report/pijar/bcc/dashboard/list',
  BCC_DETAIL_PATH: (id: string) => `/api/report/pijar/bcc/dashboard/${id}`,
  BCC_RESTAN_PATH: '/api/report/pijar/bcc/dashboard/restan',
  BCC_PER_PEMANEN_PATH: '/api/report/pijar/bcc/dashboard/pemanen',
  BCC_BA_PATH: '/api/report/pijar/bcc/dashboard/ba',
  BCC_BA_RESTAN_PATH: '/api/report/pijar/bcc/dashboard/ba-restan',
  BCC_IMAGES_DOWNLOAD_PATH: '/api/report/pijar/bcc/images/download',
  BCC_EDIT_PATH: (id: string) => `/api/internal/pijar/bcc/dashboard/${id}`,
  BCC_BA_EDIT_PATH: (id: string) => `/api/internal/pijar/bcc/dashboard/ba/${id}`,

  // SPB (Transport)
  SPB_KPI_PATH: '/api/report/pijar/spb/dashboard/kpi',
  SPB_LIST_PATH: '/api/report/pijar/spb/dashboard/list',
  SPB_DETAIL_PATH: (id: string) => `/api/report/pijar/spb/dashboard/${id}`,
  SPB_EDIT_PATH: (id: string) => `/api/internal/pijar/spb/dashboard/${id}`,

  // BKM (Foreman)
  BKM_KPI_PATH: '/api/report/pijar/bkm/dashboard/kpi',
  BKM_LIST_PATH: '/api/report/pijar/bkm/dashboard/list',
  BKM_DETAIL_PATH: (id: string) => `/api/report/pijar/bkm/dashboard/${id}`,
  BKM_SIMULATION_PATH: '/api/report/pijar/bkm/dashboard/simulation',
  BKM_EDIT_PATH: (id: string) => `/api/internal/pijar/bkm/dashboard/${id}`,

  // Configuration (Odoo master-data sync + read-only data viewer).
  // These hit the FastAPI insight-api gateway (`/api/pijar/config/*`), which proxies
  // to Sakti Go's reporting `/api/report/config/*` — NOT Sakti Go directly.
  CONFIG_SYNC_ENTITIES_PATH: '/api/pijar/config/sync/entities',
  CONFIG_SYNC_JOBS_PATH: '/api/pijar/config/sync/jobs',
  CONFIG_SYNC_JOB_DETAIL_PATH: (jobId: string) => `/api/pijar/config/sync/jobs/${jobId}`,
  CONFIG_TABLES_PATH: '/api/pijar/config/tables',
  CONFIG_TABLE_ROWS_PATH: (table: string) =>
    `/api/pijar/config/tables/${encodeURIComponent(table)}/rows`,

  // Push-to-Odoo re-sync (enqueue a Celery job on the gateway, then poll it).
  // The gateway forwards {date_start, date_end, estate_id} to Sakti Go's odoo-worker.
  PUSH_ODOO_JOBS_PATH: '/api/sakti/push-odoo/jobs',
  PUSH_ODOO_JOB_STATUS_PATH: (taskId: string) => `/api/sakti/push-odoo/jobs/${taskId}`,

  // App Config admin CRUD (backend-controlled mobile app config + feature flags)
  APP_CONFIG_ADMIN_LIST: '/api/sakti/app-config/app-configs',
  APP_CONFIG_ADMIN_DETAIL: (id: string) => `/api/sakti/app-config/app-configs/${id}`,
  FEATURE_FLAG_ADMIN_LIST: '/api/sakti/app-config/feature-flags',
  FEATURE_FLAG_ADMIN_DETAIL: (id: string) => `/api/sakti/app-config/feature-flags/${id}`,

  // Remote Database Inspection (WebSocket-based SQLite inspection for Android)
  SUPPORT_SESSIONS_PATH: '/api/sakti/support/sessions',
  SUPPORT_SESSION_CANCEL: (id: string) => `/api/sakti/support/sessions/${id}/cancel`,
  SUPPORT_SESSION_COMPLETE: (id: string) => `/api/sakti/support/sessions/${id}/complete`,
  SUPPORT_SESSION_LOGS: (id: string) => `/api/sakti/support/sessions/${id}/logs`,

  // Face Registry viewer (enrollment status + image browser)
  FACE_REGISTRY_EMPLOYEES_PATH: '/api/pijar/face-registry/employees',
  FACE_REGISTRY_JOB_POSITIONS_PATH: '/api/pijar/face-registry/job-positions',
  FACE_REGISTRY_EMPLOYEE_IMAGES_PATH: (id: number) => `/api/pijar/face-registry/employees/${id}/images`,
  FACE_REGISTRY_IMAGE_PATH: (relPath: string) => `/api/pijar/face-registry/images/${relPath}`,
  FACE_REGISTRY_BATCHES_PATH: '/api/pijar/face-registry/batches',
  FACE_REGISTRY_BATCH_DETAIL_PATH: (batchId: string) => `/api/pijar/face-registry/batches/${batchId}`,
  FACE_REGISTRY_STATS_PATH: '/api/pijar/face-registry/stats',

  // Attendance Liveness Audit
  ATTENDANCE_AUDIT_LIVENESS_PATH: '/api/report/attendance-audit/liveness',
  ATTENDANCE_AUDIT_IMAGE_PATH: (relPath: string) => `/api/report/attendance-audit/images/${relPath}`,
} as const;

export const SAKTI_DEFAULTS = {
  RECONNECT_INTERVAL_MS: 2000,
  DEFAULT_COMPANY_ID: 1,
  DEFAULT_PAGE: 1,
  DEFAULT_LIMIT: 100,
} as const;

export const SAKTI_CONFIG_DEFAULTS = {
  // Data-viewer page size mirrors Sakti Go's dataviewer.DefaultLimit (DBeaver-like).
  DATA_VIEWER_LIMIT: 200,
  // Poll interval while a sync job is running.
  SYNC_POLL_INTERVAL_MS: 2000,
  // Debounce for the data-viewer search box (each keystroke is a full-table ILIKE+COUNT).
  SEARCH_DEBOUNCE_MS: 500,
} as const;
